import { render, staticRenderFns } from "./TrackView.vue?vue&type=template&id=a065aef4&scoped=true"
import script from "./TrackView.vue?vue&type=script&lang=js"
export * from "./TrackView.vue?vue&type=script&lang=js"
import style0 from "./TrackView.vue?vue&type=style&index=0&id=a065aef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a065aef4",
  null
  
)

export default component.exports